import React from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import styled from "styled-components";

import { Box, Heading, Text } from "grommet";

import BookElement from "app/api/bookElement";

import Paragraph from "app/components/Paragraph";
import SectionBreak from "app/components/BookElements/SectionBreak";
import TableOfContentsEntry from "app/components/BookElements/TableOfContentsEntry";

const Container = styled(Box)`
  text-align: center;
`;

const ItalicText = styled(Paragraph)`
  font-style: italic;
`;

class Supplement extends React.Component {
  render() {
    const { path, content } = this.props;
    if (BookElement.isNotSelected(path)) return null;
    return (
      <Container>
        <TableOfContentsEntry path={path}>
          <Heading responsive textAlign="center">
            Publication Supplement
          </Heading>
        </TableOfContentsEntry>
        <Text as="h3" alignSelf="start" size="large" weight="bold">
          Supplemental Content
        </Text>
        <Paragraph>
          This mobile publication contains additional figure types such as
          charts and interactions that are not included in the original
          publication.
        </Paragraph>

        {content.details && <Paragraph>{content.details}</Paragraph>}
        <SectionBreak />
      </Container>
    );
  }
}

Supplement.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * details
   */
  content: PropTypes.shape({
    details: PropTypes.string,
  }),
};
Supplement.defaultProps = {
  content: {},
};

const Component = inject("AppState")(observer(Supplement));
Component.displayName = "Supplement";
export const SupplementComponent = Supplement;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Supplement.js